export const CONSENT_VERSION = 1;
export const CONSENT_UPDATED_DATE = '2026-04-01'; // date the policy text was last revised ("1st April 2026")
